import { createSlice } from '@reduxjs/toolkit'

const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    defaults: {
      cardHeight: 800,
      cardWidth: 600
    },
    FMLayoutMode: 'full',
    // These will be updated by window resize listeners in React
    smAndUp: false,
    mdAndUp: false,
  },
  reducers: {
    setDefaults: (state, action) => {
      state.defaults = { ...state.defaults, ...action.payload }
    },
    setFMLayoutMode: (state, action) => {
      state.FMLayoutMode = action.payload
    },
    setBreakpoints: (state, action) => {
      const { smAndUp, mdAndUp } = action.payload
      state.smAndUp = smAndUp
      state.mdAndUp = mdAndUp
    },
  },
})

export const { setDefaults, setFMLayoutMode, setBreakpoints } = layoutSlice.actions

// Selectors
export const selectDefaults = (state) => state.layout.defaults
export const selectFMLayoutMode = (state) => state.layout.FMLayoutMode
export const selectSmAndUp = (state) => state.layout.smAndUp
export const selectMdAndUp = (state) => state.layout.mdAndUp

export const selectCalculatedHeight = (state) => 
  state.layout.smAndUp ? state.layout.defaults.cardHeight : 'auto'

export const selectCalculatedWidth = (state) => 
  state.layout.smAndUp ? state.layout.defaults.cardWidth : 'auto'

export default layoutSlice.reducer